let table;
let options;
let data;
let filteredCategories = [];
let searchedTerm = '';

// the comments below are for disable eslint rules
function initResearchersResults() {
  if (typeof ResearchersList !== 'undefined' && $('.researchers-results').length > 0) { // eslint-disable-line no-undef
    google.charts.load('current', { // eslint-disable-line no-undef
      'packages': ['table', 'controls'], // eslint-disable-line quote-props
    });
    google.charts.setOnLoadCallback(initTable); // eslint-disable-line no-undef

    let typingTimer;
    const doneTypingInterval = 1000;
    const searchInput = $('#search-researchers');

    $('#researchers-results-filtering').on('submit', function(e) {
      e.preventDefault();
    });

    searchInput.on('keyup', function() {
      searchedTerm = $(this).val();
      displaySearchResultRows();
      displayNoResults();
      setColorOnType();
      addUrlParams(searchedTerm, filteredCategories);

      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    searchInput.on('keydown', function () {
      clearTimeout(typingTimer);
    });

    $('.filters input[type="checkbox"]').on('click', function () {
      filteredCategories = [];

      $('.filters input[type="checkbox"]:checked').each(function () {
        filteredCategories.push($(this).val());
      });

      addUrlParams(searchedTerm, filteredCategories);

      displaySearchResultRows();
      $.post($('.filters').data('filter'), { category: filteredCategories, action: 'get_related_articles' }, function(response) { $('.related-articles-result').html(response); }, 'html');
      displayNoResults();
    });

    $('.clear-all').on('click', function () {
      filteredCategories = [];

      $('.filters input[type="checkbox"]').prop('checked', false);
      displaySearchResultRows();
    });

    $('#researchers-results-controls select[name="results_per_page"]').on('change', function() {
      options.pageSize = $(this).val();
      displaySearchResultRows();
      scrollPageTop();
    });

    $('.toggle-categories').on('click', function () {
      const filterPanel = $(this).closest('.search-area').find('.filters');
      const searchFilterHeight = 120;

      $(this).toggleClass('toggle-icon');
      filterPanel.toggleClass('show-filters');
      if ($(this).hasClass('toggle-icon')) {
        $('.open-filter').removeClass('ico-filter').addClass('ico-close');
        $('html, body').animate({
          scrollTop: $('.researchers-results').offset().top - searchFilterHeight,
        }, 1000);
      } else {
        $('.open-filter').removeClass('ico-close').addClass('ico-filter');
      }
    });
  }
}

function initTable() {
  data = new google.visualization.DataTable(); // eslint-disable-line no-undef

  if (ResearchersList.cols.length > 0) { // eslint-disable-line no-undef
    $.each(ResearchersList.cols, function(key, col) { // eslint-disable-line no-undef
      data.addColumn('string', col);
    });
  }

  data.addRows(ResearchersList.rows); // eslint-disable-line no-undef
  data.sort({ column: 0 });

  table = new google.visualization.Table(document.getElementById('researchers-results')); // eslint-disable-line no-undef
  options = {
    width: '100%',
    height: '100%',
    page: 'enable',
    pageSize: $('#researchers-results-controls select[name="results_per_page"]').val(),
    pagingSymbols: {
      prev: 'Previous',
      next: 'Next',
    },
    pagingButtonsConfiguration: 'auto',
    pagingButtons: '6',
    sort: 'enable',
    sortColumn: 0,
    sortAscending: true,
    allowHtml: true,
  };

  table.draw(data, options);
  google.visualization.events.addListener(table, 'page', pageEventHandler); // eslint-disable-line no-undef
  google.visualization.events.addListener(table, 'page', showFirstPage); // eslint-disable-line no-undef
  resultRowsFullWidth();

  loadFromHash();
}

function resultRowsFullWidth() {
  $('.google-visualization-table-tr-head').append('<div class="background-wrap"></div>');
  $('tr td:first-child').append('<div class="background-wrap"></div>');
  $('.background-wrap').append('<div class="background"></div>');
  $('tr').each(function() {
    const rowHeight = $(this).height();
    const bgEl = $(this).find('.background');

    bgEl.height(rowHeight);
  });
  $('.google-visualization-table-page-numbers a:nth-child(5)').after('<span class="dots">...</span>');
}

function getSearchResultRows(data, filters) { // eslint-disable-line no-shadow
  const searchableFreeTextColumns = [0, 2];
  let filteredRows = [];

  for (const i in searchableFreeTextColumns) {
    const column = searchableFreeTextColumns[i];

    const filteredResults = data.getFilteredRows([
      {
        column: column,
        test: function(columnValue) {
          if (filters.freeTextSearchTerm.length > 1) {
            if (columnValue.indexOf('alt="') > -1) {
              return columnValue.split('alt="').pop().split('"').shift()
              .toLowerCase()
              .indexOf(filters.freeTextSearchTerm.toLowerCase()) !== -1;
            } else { // eslint-disable-line no-else-return
              return columnValue.toLowerCase().indexOf(filters.freeTextSearchTerm.toLowerCase()) !== -1;
            }
          } else { // eslint-disable-line no-else-return
            return true;
          }
        },
      },
      {
        column: 1,
        test: function(category) {
          if (filters.categoriesTerms.length > 0) {
            return $.inArray(category.replace(/[&]/g, 'and').replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g, '').toLowerCase(), filters.categoriesTerms) !== -1; // eslint-disable-line no-useless-escape
          } else { // eslint-disable-line no-else-return
            return true;
          }
        },
      },
    ]);

    filteredRows = $.merge(filteredRows, filteredResults);
  }

  return $.unique(filteredRows);
}

function displaySearchResultRows() {
  const view = new google.visualization.DataView(data); // eslint-disable-line no-undef
  if (!(searchedTerm.length < 2 && filteredCategories.length === 0)) {
    view.setRows(getSearchResultRows(
      data,
      {
        freeTextSearchTerm: searchedTerm,
        categoriesTerms: filteredCategories,
      }
    ));
  }

  table.draw(view, options);
  resultRowsFullWidth();
}

function displayNoResults() {
  const resultsField = $('.researchers-results tbody');
  const noResultsContainer = $('.no-results');
  const searchTerm = $('#searched-term');

  if (resultsField.children().length === 0) {
    $(noResultsContainer).addClass('show');
    $('.google-visualization-table-div-page').addClass('hide');
    $(searchTerm).text($('#search-researchers').val());
  } else {
    $(noResultsContainer).removeClass('show');
    $('.google-visualization-table-div-page').removeClass('hide');
  }
}

function pageEventHandler() {
  scrollPageTop();
}

function scrollPageTop() {
  const fromTop = 350;
  const searchFieldHeight = 70;

  if ($(window).scrollTop() > fromTop) {
    $('html, body').animate({
      scrollTop: $('.researchers-results').offset().top + searchFieldHeight,
    }, 1000);
  }
  resultRowsFullWidth();
}

function showFirstPage() {
  const $firstPage = $('.google-visualization-table-page-numbers a:first-child');
  const $lastPage = $('.google-visualization-table-page-numbers a:last-child');

  $firstPage.text(1);
  $firstPage.after('<span class="dots">...</span>');
  $firstPage.on('click', function() {
    displaySearchResultRows();
  });
  $lastPage.on('click', function() {
    $lastPage.after('');
  });
}

function setColorOnType() {
  const $search = $('.js-search-list');
  const $searchInput = $search.find('.search-input');

  if ($search.length > 0) {
    const inputValue = $searchInput.val();
    if (inputValue) {
      $search.addClass('is-typing');
    } else {
      $search.removeClass('is-typing');
    }
  }
}

function doneTyping () {
  const resultsField = $('.researchers-results tbody');
  const resultsOffsetTop = 420;

  if (!(searchedTerm.length < 2) && !(resultsField.children().length === 0)) {
    $('html, body').animate({
      scrollTop: resultsOffsetTop,
    }, 1000);
  }
}

function addUrlParams(terms, categories) {
  var searchTerms = '';
  if (terms !== '') {
    searchTerms = 'freeText=' + terms;
  }

  categories.filter(function(v) { return v !== ''; });

  if (!$.isEmptyObject(categories)) {
    if (searchTerms !== '') {
      searchTerms += '&';
      searchTerms += 'categories=' + categories;
    } else {
      searchTerms = 'categories=' + categories;
    }
  }

  window.location.hash = encodeURIComponent(searchTerms);
}

function loadFromHash() {
  var currentHash = decodeURIComponent(window.location.hash).slice(1);
  var array = currentHash.split('&');
  var values;
  var formData = {};
  var i;

  for (i = 0; i < array.length; i += 1) {
    values = array[i].split('=');
    formData[values[0]] = values[1];
  }

  if (formData.hasOwnProperty('freeText')) { // eslint-disable-line no-prototype-builtins
    searchedTerm = formData.freeText;
    $('.search-input').val(searchedTerm);
  }

  if (formData.hasOwnProperty('categories')) { // eslint-disable-line no-prototype-builtins
    filteredCategories = formData.categories.split(',');
    $.each(filteredCategories, function(k, v) {
      $('#' + v).attr('checked', 'checked');
    });
  }

  displaySearchResultRows();
}

export default { initResearchersResults };



// WEBPACK FOOTER //
// ./src/js/custom/researchers-results.js